<template>
    <div class="container-wrapper"
        :class="{ containerdesign: !!isDesign, selected: !!isDesign && selectWidget && selectWidget.id == widget.id }">
        <slot></slot>

        <template v-if="!!isDesign && selectWidget && selectWidget.id == widget.id">
            <div class="container-action">
                <i @click.stop="moveUpWidget"><arrow-up-outlined /></i>
                <i @click.stop="moveDownWidget"><arrow-down-outlined /></i>
                <i @click.stop="removeFieldWidget"><delete-outlined /></i>
            </div>

            <div class="drag-background" :class="{ 'drag-handler': !widget.internal }">
                <i>{{ entocn }}</i>
            </div>
        </template>
    </div>
</template>

<script setup>
import { ref, toRefs, computed, inject, defineExpose } from 'vue';
import useItem from '../useItem';

const props = defineProps({
    widget: Object,
    isDesign: Boolean,
    widgetList: Array,
    indexOfParentList: Number
})
const { widget, isDesign, widgetList, indexOfParentList } = toRefs(props)

const { getSelectWidget } = inject("designer")
const { getInstanceList } = inject("instance")

const selectWidget = computed(() => getSelectWidget())
const entocn = computed(() => {
    const obj = {
        grid: "栅格",
        "grid-col": "栅格列",
    }
    return obj[widget.value.type]
});

const {
    moveUpWidget,
    moveDownWidget,
    removeFieldWidget,
} = useItem(isDesign, widgetList, indexOfParentList)

const instanceList = getInstanceList();

const getInstance = (name) => {
    return instanceList[name];
};
const setHidden = (flag) => {
    widget.value.hidden = flag;
};
const setProptype = (key, value) => {
    widget.value.options[key] = value;
};
defineExpose({ getInstance, setHidden, setProptype })
</script>

<style>
.containerdesign {
    height: 100%;
    position: relative;
    outline: 1px dashed #336699;
}

.selected {
    border: 2px solid blue;
}

.container-action {
    position: absolute;
    bottom: 0;
    right: -2px;
    height: 22px;
    line-height: 22px;
    background: blue;
    z-index: 999;
}

.drag-background {
    position: absolute;
    top: -2px;
    left: -2px;
    height: 22px;
    line-height: 22px;
    background: blue;
    z-index: 9;
}

.drag-handler:hover {
    background: blue;
}

i {
    font-size: 14px;
    color: #fff;
    margin: 0 3px;
    cursor: pointer;
}
</style>